import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import classNames from "classnames/bind";

// styles
import styles from "./styles.module.scss";

// assets
import ArrowRightIcon from "src/assets/images/blog/ArrowRight.png";
import BlogImg from "src/assets/images/blog/blog-img-1.png";
import VirtualImg from "src/assets/images/blog/virtual.jpeg";
import ArrangeImg from "src/assets/images/blog/arrange.jpg";
import FindImg from "src/assets/images/blog/fing.png";

const cx = classNames.bind(styles);

const BlogItem = ({ data }) => {
  const [imgError, setImgError] = useState(false);
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (data) {
      let plainText = data?.BlogDescription?.replace(/<[^>]+>/g, "")
        .replaceAll("&nbsp;", "")
        .trim();
      plainText = plainText?.substring(0, 180);
      plainText += "...";

      setDescription(plainText);
    }
  }, [data]);

  const isVirtual = () => {
    if (data?.BlogTitle === "Best Virtual andLive Stream Events in 2020")
      return VirtualImg;
    if (data?.BlogTitle === "How to Arrange events during this Lock-Down")
      return ArrangeImg;
    if (
      data?.BlogTitle ===
      "How to Find Small Local Events in Your Area | Social Distancing"
    )
      return FindImg;
    else return BlogImg;
  };

  return (
    <div className={cx("blog-item-root")}>
      <Link to={`/blogs/${data?.BlogLink}`}>
        <div className={cx("blog__item")}>
          {data?.BlogImage ? (
            <img
              src={!imgError ? data?.BlogImage : isVirtual()}
              alt={data?.BlogTitle}
              onError={() => setImgError(true)}
            />
          ) : (
            <Skeleton className={cx("placeholder")} />
          )}
          <div>
            <h2>{data?.BlogTitle || <Skeleton />}</h2>
            {/* <p>{data.BlogDescription}</p> */}
            {data?.BlogDescription ? (
              <p
                className={`overview ${cx("blog__overview")}`}
                // dangerouslySetInnerHTML={{ __html: data?.BlogDescription }}
              >
                {description}
              </p>
            ) : (
              <Skeleton count={2} className={cx("overview__placeholder")} />
            )}
            {data?.BlogDescription ? (
              <button>
                <span>Discover now</span>
                <img src={ArrowRightIcon} alt="arrow" />
              </button>
            ) : (
              <Skeleton className={cx("btn__placeholder")} />
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default BlogItem;
